export { EllipseBox } from './EllipseBox'
export { EllipseBoxData } from './data/EllipseBoxData'
export { PolygonBox } from './PolygonBox'
export { PolygonBoxData } from './data/PolygonBoxData'
export { StarBox } from './StarBox'
export { StarBoxData } from './data/StarBoxData'
export { PathBox } from './PathBox'
export { PathBoxData } from './data/PathBoxData'
export { ImageBox } from './ImageBox'
export { ImageBoxData } from './data/ImageBoxData'

import { Plugin } from '@leafer-ui/draw'

Plugin.add('box')